import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-bottom: 8px;
  color: var(--text-soft);
  ${typographyV2.bodyXs};
`;
